<template>
  <div class="results_statistical">
    <a-card :bordered="false"
            style="width: 100%"
            class="derail_card">
      <div slot="title">
        <h4>数据概览</h4>
      </div>
      <div class="row-box">
        <a-radio-group v-model="activeTab"
                       @change="getDataReport">
          <a-radio-button value="a"> 曝光量 </a-radio-button>
          <a-radio-button value="b"> 播放次数 </a-radio-button>
          <a-radio-button value="c"> 播放点位 </a-radio-button>
        </a-radio-group>
        <a-radio-group class="box-item"
                       @change="getDataReport"
                       v-model="radioPlayTime">
          <a-radio-button value="">全部</a-radio-button>
          <a-radio-button value="7">近7天</a-radio-button>
          <a-radio-button value="30">近30天</a-radio-button>
        </a-radio-group>
        <a-range-picker @change="rangeChange"
                        :value="formatTime"
                        format="YYYY-MM-DD"
                        :disabledDate="disabledEndDate" />
      </div>
      <div class="echart_box">
        <v-chart style="margin-left: 32px; width: calc(100% - 356px)"
                 :padding="[10, 'auto', 'auto', 'auto']"
                 :forceFit="true"
                 :height="height"
                 :data="reportChartData"
                 :scale="reportChartScale">
          <v-tooltip />
          <!-- 坐标轴 -->
          <v-axis />
          <!-- 图例 -->
          <v-legend />
          <v-line position="date*value"
                  :size="2"
                  :color="areaColor"
                  adjust="stack" />
          <v-stack-area position="date*value"
                        :color="areaColor" />
        </v-chart>
        <a-table :columns="reportTableColumn"
                 :data-source="reportTableData"
                 :loading="loading"
                 rowKey="date"
                 class="reportTableClass"
                 :pagination="false"
                 width="356"
                 :scroll="{ y: 338 }">
          <template slot="splitEle"
                    slot-scope="splitText">
            <span>{{ splitText | TableNumberFormat }}</span>
          </template>
          <template slot="rate"
                    slot-scope="rateValue">
            <span class="rate-text">{{ rateValue.toFixed(2) + "%" }}</span>
          </template>
        </a-table>
      </div>
      <div class="table_box">
        <p class="info_box">
          <a-icon type="info-circle"
                  tip="Loading..." />
          设备在线 <span>{{ countPlanPointInfo.onlineCount }}</span> 个，
          设备离线
          <span style="color: rgb(255, 77, 79)">{{
            countPlanPointInfo.offLineCount
          }}</span>
          个，上刊截屏
          <span>{{ countPlanPointInfo.publishCount }}</span> 个，下刊截屏
          <span>{{ countPlanPointInfo.downCount }}</span> 个
          <span class="export_excel"
                @click="exportExcel">导出明细</span>
          <span class="monitoring_report"
                @click="showReport">监播报告</span>
        </p>
        <addPlanDetailSelect ref="playDetailTable"
                             @callback="getPlayDetailList" />
        <a-table :columns="playTableColumns"
                 :dataSource="playTableList"
                 :scroll="{ x: 1500 }"
                 class="detail_table"
                 :pagination="false"
                 @change="columnsFilter">
          <template slot="onlineStatus"
                    slot-scope="onlineStatus">
            <p>
              <span v-if="onlineStatus == '1'">
                <a-badge status="success" />
                <span>设备在线</span>
              </span>
              <span v-else-if="onlineStatus == '0'">
                <a-badge status="warning" />
                <span>设备离线</span>
              </span>
              <span v-else-if="onlineStatus == '2'">
                <a-badge status="error" />
                <span>离线超时</span>
              </span>
              <span v-else>
                <span>--</span>
              </span>
            </p>
          </template>
          <div slot="filterDropdown"
               slot-scope="{
              setSelectedKeys,
              selectedKeys,
              confirm,
              clearFilters,
              column,
            }"
               class="custom-filter-dropdown">
            <a-input :placeholder="`搜索${column.title}`"
                     :value="selectedKeys[0]"
                     @change="
                (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
              "
                     @pressEnter="() => handleSearch(selectedKeys, confirm)"
                     style="width: 188px; margin-bottom: 8px; display: block" />
            <a-button type="primary"
                      @click="() => handleSearch(selectedKeys, confirm)"
                      icon="search"
                      size="small"
                      style="width: 90px; margin-right: 8px">搜索
            </a-button>
            <a-button @click="() => handleReset(clearFilters)"
                      size="small"
                      style="width: 90px">重置
            </a-button>

          </div>
          <a-icon slot="filterIcon"
                  slot-scope="filtered"
                  type="search"
                  :style="{ color: filtered ? '#108ee9' : undefined }" />
          <template slot="lastIssue"
                    slot-scope="row">
            <!-- <span v-if="/^(0|4|1|5|-1|-999)$/.test(planInfo.status)">--</span> -->
            <span v-if="[0,4,1,5,-1,-999].includes(planInfo.status)">--</span>
            <div v-else-if="planInfo.status === 2">
              <a-popover placement="topLeft"
                         trigger="click"
                         v-if="!row.adPlanScreenShotInfo.length && !row.clickPublishStatus">
                <template slot="content">
                  <div class="click-toast">
                    <p>
                      <a-icon type="exclamation-circle"
                              style="color: #faad14;margin-right:8px"
                              theme="filled" />请选择执行截屏操作的媒体
                    </p>
                    <div class="click-toast-footer">
                      <a-button @click="clickPublish(row)">当前媒体</a-button>
                      <a-button @click="screenShotAllPoint()">全部未截屏媒体</a-button>
                      <!-- <a-button size="small"
                                @click="clickPublish(false)">取消</a-button>
                      <a-button type="primary"
                                :size="'small'"
                                @click="clickPublish(row)">确定</a-button> -->
                    </div>
                  </div>
                </template>
                <a>截屏</a>
              </a-popover>
              <span v-if="!row.adPlanScreenShotInfo.length && row.clickPublishStatus">已通知截屏</span>
              <a v-if="row.adPlanScreenShotInfo.length"
                 @click="handleShowScreenCapture(row)">{{row.adPlanScreenShotInfo.length}}张</a>
            </div>
            <div v-else>
              <span v-if="!row.adPlanScreenShotInfo.length">--</span>
              <a v-else
                 @click="handleShowScreenCapture(row)">{{row.adPlanScreenShotInfo.length}}张</a>
            </div>
          </template>
        </a-table>
        <div class="page-wrap">
          <a-pagination :showTotal="(total) => `共 ${total} 条`"
                        :pageSizeOptions="pageSizeOptions"
                        :total="pageInfo.pageTotal"
                        showSizeChanger
                        showQuickJumper
                        :pageSize="pageInfo.pageSize"
                        v-model="pageInfo.current"
                        @showSizeChange="onShowSizeChange"
                        @change="changePage">
          </a-pagination>
        </div>
      </div>
    </a-card>
    <!--查看大图-->
    <a-modal :title="previewImgModalTitle"
             v-model="previewImgModal"
             :footer="null"
             width="390px"
             :zIndex="1002">
      <div class="img-box">
        <img :src="previewUrl"
             alt />
      </div>
    </a-modal>
    <!--监播报告-->
    <a-modal class="report-model"
             width="928px"
             title="监播报告"
             v-model="reportModel">
      <a-radio-group buttonStyle="solid"
                     v-model="reportType"
                     @change="showReport"
                     style="margin-bottom: 32px">
        <a-radio-button value="1">上刊报告</a-radio-button>
        <a-radio-button value="2">下刊报告</a-radio-button>
        <a-radio-button value="3">换画报告</a-radio-button>
      </a-radio-group>
      <div style="position: relative"
           :style="{ paddingBottom: reportTotal > 6 ? '32px' : '0' }">
        <div v-if="reportList.length == 0">
          <img src="../../assets/images/no-play-list.png"
               alt
               style="margin-bottom: 12px; width: 117px" />
          <p style="color: #b7b9be"
             v-if="reportType == 1">暂无上刊报告</p>
          <p style="color: #b7b9be"
             v-if="reportType == 2">暂无下刊报告</p>
          <p style="color: #b7b9be"
             v-if="reportType == 3">暂无换画报告</p>
          <a v-if="reportList.length == 0 &&
                planInfo.status == 2 ||
              planInfo.status == 6 ||
              planInfo.status == 7 ||
              planInfo.status == 10
            "
             @click="generateReport(reportType)">立即生成</a>
          <span v-else-if="
              /^(1|2)$/.test(reportType) &&
              generateReportArr.includes(reportType) &&
              planInfo.status === 2
            ">生成中</span>
        </div>
        <div v-else>
          <div class="cards-wrap"
               :style="{
              justifyContent: reportTotal == 1 ? 'center' : 'space-between',
            }">
            <div class="card"
                 v-for="(item, index) in reportList"
                 :key="index">
              <div class="card-top">
                <img class="card-img"
                     :src="item.materialImg"
                     alt />
                <div class="card-time">
                  {{ item.updateTime }}
                  <div>
                    <span>更新</span>
                  </div>
                </div>
                <div class="card-count">
                  <span>计划：{{ item.planCount }}个</span>
                  <span>|</span>
                  <span v-if="reportType == 1">上刊：{{ item.realCount }}个</span>
                  <span v-if="reportType == 2">下刊：{{ item.realCount }}个</span>
                  <span v-if="reportType == 3">换画：{{ item.realCount }}个</span>
                </div>
              </div>
              <div class="card-bottom">
                <div @click="updateReport(item)">
                  <a-icon type="sync" />更新
                </div>
                <div @click="downloadReport(item)">
                  <a-icon type="download" />下载
                </div>
              </div>
            </div>
          </div>
          <a-pagination v-if="reportTotal > 6"
                        class="report-page"
                        v-model="reportPage"
                        :total="reportTotal"
                        :pageSize="6"
                        @change="changeReportPage" />
        </div>
      </div>
      <template slot="footer">
        <a-button @click="reportModel = false">关闭</a-button>
      </template>
    </a-modal>
    <!-- //截屏弹窗isShowScreenCapture -->
    <a-modal :title="isShowScreenCaptureTitle"
             v-model="isShowScreenCapture"
             :okText="okText"
             cancelText="关闭"
             @ok="() => okScreenCaptureModel()"
             :ok-button-props="okButtonProps"
             @cancel="() => cancelScreenCaptureModel()"
             width="320px"
             :zIndex="1002"
             class="screen_capture"
             destroyOnClose>
      <scrennCapture @refresh="refreshPlayDetailTable"
                     :adPlanScreenShotInfo.sync="adPlanScreenShotInfo"
                     @changeInfo="handlerChangeInfo" />
    </a-modal>
  </div>
</template>
<script>
import timeFormat from '../../commomFun/timeFormat'
import moment from 'moment'
import api from '../../commomFun/api.js'
import addPlanDetailSelect from './selectGroup'
import $ from 'jquery'
import scrennCapture from './screenCapture//index.vue'

export default {
  components: {
    addPlanDetailSelect,
    scrennCapture,
  },
  props: {
    planInfo: {
      type: Object,
      required: true,
      default: () => {},
    },
    countPlanPointInfo: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      isEndTimeStatus: false,
      generateReportArr: [],
      planId: '',
      echartSpinning: false,
      rangeTime: [],
      formatTime: [],
      PlayNumberCountInfo: {
        communityCount: 0,
        doorCount: 0,
        playTotal: 0,
      },
      // 表格数据
      playTableList: [],
      playTableColumns: [
        {
          title: '城市',
          key: 'city',
          dataIndex: 'city',
          customRender: (text, record, index) => record.city || '--',
          width: 100,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '网点资源',
          key: 'communityName',
          dataIndex: 'communityName',
          customRender: (text, record, index) => record.communityName || '--',
          width: 120,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '点位名称',
          key: 'deviceName',
          dataIndex: 'deviceName',
          customRender: (text, record, index) => record.deviceName || '--',
          width: 120,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '播放次数',
          key: 'playCount',
          dataIndex: 'playCount',
          width: 100,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '曝光人次',
          key: 'exposureCount',
          dataIndex: 'exposureCount',
          customRender: (text, record, index) => record.exposureCount,
          ellipsis: true,
          align: 'center',
        },
        {
          title: '曝光人数',
          key: 'exposureNumber',
          dataIndex: 'exposureNumber',
          customRender: (text, record, index) => record.exposureNumber,
          ellipsis: true,
          align: 'center',
        },
        {
          title: '设备型号',
          key: 'deviceModelText',
          dataIndex: 'deviceModelText',
          customRender: (text, record, index) => record.deviceModelText || '--',
          filters: [
            { text: 'QLG19-C215', value: '7' },
            { text: 'GWS19-49', value: '12' },
            { text: 'QLL19-C32', value: '13' },
            { text: 'QLG19-215', value: '14' },
            { text: 'QLL19-32', value: '15' },
            { text: 'QLG2020-R8', value: '17' },
          ],
          filterMultiple: false,
          width: 120,
          align: 'left',
          ellipsis: true,
        },
        {
          title: 'MAC',
          key: 'mac',
          dataIndex: 'mac',
          customRender: (text, record, index) => record.mac || '--',
          align: 'left',
          ellipsis: true,
        },
        {
          title: '楼盘类型',
          key: 'buildType',
          dataIndex: 'buildType',
          customRender: (text, record, index) => record.buildType || '--',
          width: 100,
          align: 'left',
          ellipsis: true,
        },
        {
          title: '户数',
          key: 'buildNumber',
          dataIndex: 'buildNumber',
          customRender: (text, record, index) => record.buildNumber || '--',
          width: 100,
          align: 'left',
          ellipsis: true,
        },
        {
          title: '价格',
          key: 'buildPrice',
          dataIndex: 'buildPrice',
          customRender: (text, record, index) => record.buildPrice || '--',
          width: 100,
          align: 'left',
          ellipsis: true,
        },
        {
          title: '连续在线',
          key: 'onlineDayNum',
          dataIndex: 'onlineDayNum',
          sorter: true,
          width: 100,
          align: 'left',
          ellipsis: true,
        },
        {
          title: '截屏图片',
          key: 'lastIssue',
          scopedSlots: { customRender: 'lastIssue' },
          filters: [
            { text: '未截屏', value: '0' },
            { text: '已截屏', value: '1' },
          ],
          filterMultiple: false,
          width: 100,
          fixed: 'right',
          align: 'left',
        },
        {
          title: '网络情况',
          key: 'onlineStatus',
          dataIndex: 'onlineStatus',
          scopedSlots: { customRender: 'onlineStatus' },
          filters: [
            { text: '全部', value: '' },
            { text: '设备在线', value: '1' },
            { text: '设备离线', value: '0' },
            { text: '离线超时', value: '2' },
          ],
          filterMultiple: false,
          fixed: 'right',
          width: 100,
          align: 'left',
          ellipsis: true,
        },
      ],
      pageSizeOptions: ['5', '10', '20', '30', '40', '100', '200', '500'],
      pageInfo: {
        pageTotal: 0,
        pageSize: 5,
        current: 1,
      },
      toDay: timeFormat.getDateBeforeNow(0, '-'),
      // 图表
      playNumberLineEcharts: '',
      playNumberEchartsTitle: [],
      playNumberEchartsData: [],
      reportChartData: [],
      reportChartScale: [
        {
          dataKey: 'date',
          type: 'time',
          tickCount: 30,
          label: {
            // density: 0.3,
            rotate: 90,
          },
        },
        {
          dataKey: 'value',
        },
      ],
      height: 400,
      areaColor: [
        'reportType',
        ['rgba(91, 143, 249, 1)', 'rgba(90, 216, 166, 1)'],
      ],
      activeTab: 'a',
      radioPlayTime: '-1',
      reportTableColumn: [],
      reportTableColumn1: [
        {
          title: '日期',
          key: 'date',
          dataIndex: 'date',
          width: 100,
          align: 'left',
        },
        {
          title: '曝光人数',
          key: 'exposureNumber',
          dataIndex: 'exposureNumber',
          align: 'right',
        },
        {
          title: '曝光人次',
          key: 'exposureCount',
          dataIndex: 'exposureCount',
          align: 'right',
        },
      ],
      reportTableColumn2: [
        {
          title: '日期',
          key: 'date',
          dataIndex: 'date',
          width: 100,
          align: 'left',
        },
        {
          title: '播放次数',
          key: 'playQuantity',
          dataIndex: 'playQuantity',
          align: 'right',
        },
      ],
      reportTableColumn3: [
        {
          title: '日期',
          key: 'date',
          dataIndex: 'date',
          width: 100,
          align: 'left',
        },
        {
          title: '播放点位数',
          key: 'pointCount',
          dataIndex: 'pointCount',
          align: 'right',
        },
      ],
      reportTableData: [],
      loading: false,
      //监播报告相关
      reportModel: false,
      reportType: '1',
      reportList: [
        {
          materialImg: '',
          updateTime: '2020-03-06 00:42',
          realCount: 320,
          planCount: 300,
          url: 'ppt地址',
        },
      ],
      reportPage: 1,
      reportTotal: 1,
      filterObj: {
        onlineStatus: '',
        deviceModel: '',
        // 是否上刊
        publish: '',
        // 是否下刊
        down: '',
        //筛选排序方式
      },
      previewImgModalTitle: '',
      previewUrl: '',
      previewImgModal: false,
      isShowScreenCapture: false, //是否显示截屏弹窗
      isShowScreenCaptureTitle: '', //截屏弹窗标题
      adPlanScreenShotInfo: [], // 截屏弹窗数据
      timer: 0, //点击截屏弹窗截屏按钮定时器
      okButtonProps: {
        props: { disabled: false },
      },
      okText: '截屏', //截屏按钮
      isClickScreenShotBtn: false, //截屏按钮节流
    }
  },
  mounted() {
    this.planId = sessionStorage.getItem('planId')
    this.initTime()
    this.getDataReport()
    this.getPlayDetailList()
    this.isEndTime()
    // 投放计划播放统计信息
    // this.getPlayNumberCount()
  },
  methods: {
    isEndTime() {
      const endTime = new Date(
        moment(this.planInfo.endTime).format('YYYY-MM-DD') + ' 00:00:00'
      ).getTime()
      const toDay = new Date(
        moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00'
      ).getTime()
      return endTime == toDay
    },
    initTime() {
      let starTime = timeFormat.getDateBeforeNow(7, '-')
      let endTime = timeFormat.getDateBeforeNow(1, '-')
      this.rangeTime = [starTime, endTime]
      this.formatTime = [
        moment(starTime, 'YYYY-MM-DD'),
        moment(endTime, 'YYYY-MM-DD'),
      ]
    },
    radioChangeTime() {
      let params = {
        planId: this.planInfo.planId,
      }
      if (this.radioPlayTime == '') {
        // 将结束时间和当天比较
        let { beginTime, endTime } = this.planInfo,
          beginDate = null,
          endDate = null
        try {
          // 计划日期转年月日
          beginDate = new Date(beginTime)
          beginDate =
            beginDate.getFullYear() +
            '-' +
            (beginDate.getMonth() + 1) +
            '-' +
            beginDate.getDate()
          endDate = new Date(endTime)
          endDate =
            endDate.getFullYear() +
            '-' +
            (endDate.getMonth() + 1) +
            '-' +
            endDate.getDate()
        } catch (error) {
          console.error('计划结束日期格式错误', error)
          return
        }
        let yestoday = new Date(timeFormat.getDateBeforeNow(1, '-'))
        // 昨日在计划日期中间
        if (
          new Date(endDate).getTime() > yestoday.getTime() &&
          new Date(beginDate).getTime() < yestoday.getTime()
        ) {
          endDate =
            yestoday.getFullYear() +
            '-' +
            (yestoday.getMonth() + 1) +
            '-' +
            yestoday.getDate()
        }
        params.beginDate = beginDate
        params.endDate = endDate
      } else if (this.radioPlayTime == '7') {
        params.beginDate = timeFormat.getDateBeforeNow(7, '-')
        params.endDate = timeFormat.getDateBeforeNow(1, '-')
      } else if (this.radioPlayTime == '30') {
        params.beginDate = timeFormat.getDateBeforeNow(30, '-')
        params.endDate = timeFormat.getDateBeforeNow(1, '-')
      } else {
        return
      }
      return params
    },
    // 限制时间选择
    disabledEndDate(val) {
      return val > Date.parse(this.toDay)
    },
    // 选择时间
    rangeChange(selectedDate, formattedDate) {
      this.formatTime = selectedDate
      this.rangeTime = formattedDate
      this.radioPlayTime = '-1'
      this.getDataReport()
    },
    // 数据报告，曝光人数、曝光人次、播放次数、播放点位
    getDataReport() {
      let params = null
      if (this.radioPlayTime == '-1') {
        params = {
          beginDate: this.rangeTime[0],
          endDate: this.rangeTime[1],
          planId: this.planId,
        }
      } else {
        params = this.radioChangeTime()
      }
      // 播放点位和时间有切换时，调用listPlanPlayPointCount
      if (this.activeTab == 'c') {
        api.postApi('/adPlan/listPlanPlayPointCount', params).then((res) => {
          if (res.data.code == 200 && Array.isArray(res.data.data)) {
            this.reportTableColumn = this.reportTableColumn3
            this.reportTableData = res.data.data || []
            this.reportChartData = this.reportTableData.map((item) => {
              return {
                reportType: '播放点位',
                date: item.date,
                value: item.pointCount || 0,
              }
            })
            this.reportTableData.reverse()
          }
        })
      } else if (this.activeTab == 'a' || this.activeTab == 'b') {
        // 曝光量、播放次数和时间切换时，调用listPlanPlayInfo接口
        api.postApi('/adPlan/listPlanPlayInfo', params).then((res) => {
          if (res.data.code == 200 && Array.isArray(res.data.data)) {
            if (this.activeTab == 'a') {
              this.reportTableColumn = this.reportTableColumn1
              let tempReportChartData = []
              res.data.data.forEach((item) => {
                tempReportChartData.push({
                  reportType: '曝光人数',
                  date: item.date,
                  value: item.exposureNumber || 0,
                })
                tempReportChartData.push({
                  reportType: '曝光人次',
                  date: item.date,
                  value: item.exposureCount || 0,
                })
              })

              this.reportChartData = tempReportChartData
            } else {
              this.reportTableColumn = this.reportTableColumn2
              let tempReportChartData = []
              res.data.data.forEach((item) => {
                tempReportChartData.push({
                  reportType: '播放次数',
                  date: item.date,
                  value: item.playQuantity || 0,
                })
              })
              this.reportChartData = tempReportChartData
            }
            this.reportTableData = res.data.data.reverse()
          }
        })
      }
    },
    // 投放计划播放统计信息
    getPlayNumberCount() {
      let params = {
        planId: this.planId,
        beginTime: this.rangeTime[0],
        endTime: this.rangeTime[1],
      }
      api.getApi('/adPlan/getAdPlanPlayCountInfo', params).then((res) => {
        if (res.data.code === 200) {
          let resData = res.data.data
          this.PlayNumberCountInfo = {
            communityCount: resData.communityCount,
            doorCount: resData.doorCount,
            playTotal: resData.playTotal,
          }
        } else {
          this.$message.warn(res.data.msg || '播放统计获取异常')
        }
      })
    },
    // 导出明细
    exportExcel() {
      let params = {
        planId: this.planId,
        beginTime: this.rangeTime[0],
        endTime: this.rangeTime[1],
      }
      api.getApi_file('/adPlan/getAdPlanPlayInfoExcel', params).then((res) => {
        let time = timeFormat.toDateTime(new Date(), '').split(' ')
        let timeString = time[0] + time[1].split(':').join('')
        let blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel;charset=utf-8',
        })
        if (navigator.msSaveBlob) {
          // 启用IE内置下载器下载
          try {
            window.navigator.msSaveBlob(
              blob,
              timeString + this.planInfo.planName + '.xlsx'
            )
          } catch (e) {
            console.log(e)
          }
        } else {
          let downloadElement = document.createElement('a')
          let href = window.URL.createObjectURL(blob) //创建下载的链接
          downloadElement.href = href
          downloadElement.download =
            timeString + this.planInfo.planName + '.xlsx' //下载后文件名
          downloadElement.target = '_blank' // 针对 ie模式 的浏览器
          document.body.appendChild(downloadElement)
          downloadElement.click() //点击下载
          document.body.removeChild(downloadElement) //下载完成移除元素
          window.URL.revokeObjectURL(href) //释放掉blob对象
        }
      })
    },

    // 分页条数
    onShowSizeChange(current, pageSize) {
      this.pageInfo.current = current
      this.pageInfo.pageSize = pageSize
      this.getPlayDetailList()
    },
    // 页数
    changePage(page) {
      this.pageInfo.current = page
      this.getPlayDetailList()
    },
    //表格内搜索
    handleSearch(selectedKeys, confirm) {
      confirm()
    },
    handleReset(clearFilters) {
      clearFilters()
    },
    // 表头过滤
    columnsFilter(pagination, filters, sorter) {
      console.log('排序的类型', sorter)
      if (sorter.field == 'onlineDayNum') {
        this.filterObj.sortField = 'onlineDayNum'
        if (sorter.order == 'ascend') {
          this.filterObj.sortMode = 'asc'
        } else if (sorter.order == 'descend') {
          this.filterObj.sortMode = 'desc'
        } else {
          this.filterObj.sortMode = null
        }
      } else {
        this.filterObj.sortField = null
      }
      if (filters.deviceModelText)
        this.filterObj.deviceModel = filters.deviceModelText[0]
      if (filters.onlineStatus)
        this.filterObj.onlineStatus = filters.onlineStatus[0]
      if (filters.lastIssue) this.filterObj.publish = filters.lastIssue[0]
      if (filters.lower) this.filterObj.down = filters.lower[0]
      this.getPlayDetailList()
    },
    // 获取播放详情列表
    getPlayDetailList(filterParams) {
      let params = {
        ...filterParams,
        ...this.filterObj,
        planId: this.planId,
        pageNum: this.pageInfo.current,
        pageSize: this.pageInfo.pageSize,
      }
      Object.keys(params).forEach((key) => {
        if (params[key] === '') {
          delete params[key]
        }
      })
      api.postApi('/adPlan/pagePlanMachinePlayInfo', params).then((res) => {
        if (res.data.code === 200 && res.data.data) {
          let resData = res.data.data.list || []
          this.playTableList = resData.map((item, index) => {
            return {
              key: index,
              city: item.cityName || '--',
              communityName: item.communityName || '--',
              deviceCode: item.deviceCode || '--',
              deviceModel: item.deviceModel,
              deviceModelText: item.deviceModelText || '--',
              deviceName: item.deviceName || '--',
              downScreenShotUrl: item.downUrl || '',
              pointId: item.pointId,
              publishScreenShotUrl: item.publishUrl || '',
              mac: item.mac || '--',
              onlineStatus: item.onlineStatus,
              playCount: item.playCount || '--',
              buildType: item.buildType,
              buildNumber: item.buildNumber || '--',
              buildPrice: item.price || '--',
              // residentCount: item.residentCount,
              exposureNumber: item.exposureNumber,
              exposureCount: item.exposureCount,
              onlineDayNum: item.onlineDayNum + '天',
              adPlanScreenShotInfo: item.adPlanScreenShotInfo,
              clickPublishStatus: false, //添加是否发送截屏通知字段
            }
          })
          this.pageInfo.pageTotal = res.data.data.total
        } else {
          this.$message.warn('播放统计获取失败')
        }
      })
    },
    // 说明弹窗
    /* showExplain() {
      this.$info({
        title: '说明',
        content: (
          <div>
            <p>
              <span style="fontWeight: bold;">下发通知失败：</span>
              指通知设备下载物料但设备无响应，需检查设备网络或是否开机；
            </p>
            <p>
              <span style="fontWeight: bold;">下载失败：</span>
              指设备反馈尝试下载物料但失败，需检查设备内存、流量或开机情况；
            </p>
          </div>
        ),
        onOk() {}
      })
    }, */
    /**
     * 监播报告
     * */
    showReport() {
      //获取监播报告数据
      let info = {
        planId: this.planId,
        reportType: this.reportType,
        pageNum: this.reportPage,
      }
      api.getApi('/report/list', info).then((res) => {
        if (res.data.code == 200) {
          this.reportTotal = res.data.data.total
          this.reportList = res.data.data.list
        } else {
          this.$message.warning(res.data.mag)
        }
      })
      this.reportModel = true
    },
    changeReportPage(page, pageSize) {
      this.reportPage = page
      this.showReport()
    },
    //更新监播报告
    updateReport(item) {
      api.postApi('/report/update', { reportId: item.id }).then((res) => {
        if (res.data.code == 200) {
          let time = timeFormat.toDateTime(new Date())
          item.updateTime = time.substring(0, time.lastIndexOf(':'))
          this.$message.success('更新成功')
        } else {
          this.$message.warning(res.data.msg)
        }
      })
    },
    //下载监播报告
    downloadReport(item) {
      if (item.url) {
        let downloadElement = document.createElement('a')
        let href = item.url
        let downloadName =
          item.updateTime +
          '-' +
          this.planInfo.planName +
          '-' +
          timeFormat.toDateTime2(new Date())
        downloadElement.href = href
        downloadElement.download = downloadName + '.pptx' //下载后文件名
        document.body.appendChild(downloadElement)
        downloadElement.click() //点击下载
        document.body.removeChild(downloadElement) //下载完成移除元素
        this.reportModel = false
        this.$success({
          title: '请在下载工具里查看文件',
          // JSX support
          content: '文件生成成功，正在下载',
        })
      } else {
        this.$message.warning('下载监播报告失败！')
      }
    },
    generateReport(status) {
      switch (Number(status)) {
        case 1:
          this.generateReportApi(
            '/report/generatePublishReport?planId=',
            status
          )
          break
        case 2:
          this.generateReportApi('/report/generateDownReport?planId=', status)
          break
        case 3:
          this.generateReportApi(
            '/report/generateReplaceReport?planId=',
            status
          )
          break
        default:
          break
      }
    },
    generateReportApi(url, status) {
      api
        .postApi_header(url + this.planId)
        .then((res) => {
          const { code } = res.data
          if (code === 200) {
            this.generateReportArr.push(status)
            this.$message.success('请求成功！')
          } else {
            this.$message.error('截屏失败，请重试！')
          }
        })
        .catch((err) => this.$message.error('截屏失败，请重试！'))
    },
    clickPublish(row) {
      let _this = this
      $('.ant-popover').css({ display: 'none' })
      if (!row) return
      api
        .postApi_header('/adMachineScreenShot/screenShot', '', {
          planId: this.planId,
          pointId: row.pointId,
          type: 0,
        })
        .then((res) => {
          const { code } = res.data
          if (code === 200) {
            row.clickPublishStatus = true
            // this.$nextTick(() => {
            //   _this.$set(row, { clickPublishStatus: true })
            // })
          }
        })
    },
    handleShowScreenCapture(row) {
      //还原截屏按钮样式
      this.okText = '截屏'
      this.okButtonProps.props.disabled = false
      //设置数据传入
      this.currentPointId = row.pointId
      this.adPlanScreenShotInfo = row.adPlanScreenShotInfo
      this.isShowScreenCaptureTitle = row.communityName + '-' + row.deviceName
      this.isShowScreenCapture = true
    },
    //截屏弹窗 ok事件
    okScreenCaptureModel() {
      if (this.isClickScreenShotBtn) return
      this.isClickScreenShotBtn = true
      // this.isShowScreenCapture = false
      api
        .postApi_header('/adMachineScreenShot/screenShot', '', {
          planId: this.planId,
          pointId: this.currentPointId,
          type: 0,
        })
        .then((res) => {
          const { code } = res.data
          if (code === 200) {
            this.$message.success('成功发送截屏请求')
            this.setCountDown() //设置按钮倒计时样式
          } else {
            this.$message.error('发送截屏请求失败')
          }
          this.isClickScreenShotBtn = false
        })
        .catch((err) => {
          console.log(err)
          this.isClickScreenShotBtn = false
        })
    },
    //关闭截图弹窗
    cancelScreenCaptureModel() {
      this.isShowScreenCapture = false
      clearInterval(this.timer)
      this.timer = null
    },
    // 刷新表格
    refreshPlayDetailTable() {
      this.$refs.playDetailTable.handleSearch()
    },
    //截取所有媒体截图
    screenShotAllPoint() {
      let _this = this
      $('.ant-popover').css({ display: 'none' })
      let params = {
        planId: this.planId,
        // pointId: 0,
        type: 0,
      }
      api
        .postApi('/adMachineScreenShot/screenShotAllPoint', params)
        .then(({ data }) => {
          if (data.code == 200) {
            this.$message.success('发送全部未截屏媒体截图申请成功')
            this.playTableList.forEach((item) => {
              item.clickPublishStatus = true
            })
          } else {
            this.$message.error('发送全部未截屏媒体截图申请失败')
          }
        })
    },
    //设置按钮样式，不可点击
    setCountDown() {
      this.okButtonProps.props.disabled = true
      let num = 60
      this.timer = setInterval(() => {
        num--
        if (num <= 0) {
          this.okButtonProps.props.disabled = false
          this.okText = '截屏'
          clearInterval(this.timer)
          this.timer = null
        } else {
          this.okText = `截屏(${num})`
        }
      }, 1000)
    },
    handlerChangeInfo({ id, type }) {
      this.adPlanScreenShotInfo.filter((item) => {
        return item.id == id
      })[0].type = type
    },
  },
}
</script>
<style lang="scss" scoped>
.reportTableClass {
  width: 356px;
  height: 400px;
  margin-right: 32px;
  /deep/ .ant-table-placeholder {
    height: 338px;
  }
  /deep/ .ant-table-body,
  /deep/ .ant-table-thead {
    td,
    th {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 16px 8px;
    }
  }
}
.echart_box {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}

.row-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px;
  .box-item {
    margin: 0 0 0 auto;
  }
}
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}

.content {
  background: #fff;
  width: 100%;
  position: relative;

  .header_btn {
    width: 100%;
    font-size: 20px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    position: relative;
    top: -15px;
    padding-left: 32px;

    span {
      display: inline-block;
      width: 28px;
      height: 28px;
      background-size: 720px 720px !important;
      background: url('../../../public/images/cssSprite.png') no-repeat -260px -24px;
      margin-right: 10px;
      position: relative;
      top: 7px;
    }

    .btn-group {
      position: absolute;
      top: 0;
      right: 64px;

      button {
        margin-left: 8px;
        padding: 0;
      }
    }
  }
}

.info-wrap {
  position: relative;
  padding: 0 64px 0 76px;

  .left-part {
    h6 {
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 8px;
    }

    > div {
      .ant-row,
      .ant-row-flex {
        margin-bottom: 8px;
      }

      em {
        color: rgba(0, 0, 0, 0.85);
      }
    }
    .area {
      padding-bottom: 32px;

      span,
      a {
        font-weight: normal;
      }

      p {
        font-weight: bold;
      }
    }
  }
  .right-part {
    position: absolute;
    right: 64px;
    top: 0;

    dt {
      color: rgba(0, 0, 0, 0.45);
      text-align: right;
    }

    dd {
      color: rgba(0, 0, 0, 0.85);
      font-size: 20px;
    }
  }
}

.info {
  margin-bottom: 16px;
}

/* 投放区域对话框 */
.area-ul {
  border: 1px solid #d8d8d8;
  border-radius: 4px;

  .area-li {
    width: 100%;
    border-bottom: 1px solid #d8d8d8;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    padding: 0 16px;

    & :last-of-type {
      border-bottom: none;
    }

    .first_area_li {
      width: 60%;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    .second_area_li {
      width: 22%;
    }
  }
}

.ant-upload > div {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.img-box,
.video-box {
  text-align: center;
}

.img-box img {
  width: 320px;
  height: auto;
}

.video-box video {
  width: 320px;
  height: auto;
}

/deep/ .echarts_tooltip_title {
  width: 200px;
  height: 36px;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  align-items: center;
  box-sizing: border-box;
  margin-bottom: -20px;
  color: #808080;
  background-color: #f4f6f6;
  font-size: 12px;
}

/deep/ .echarts_tooltip_content {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  box-sizing: border-box;
  align-items: center;
  font-size: 12px;
  color: #2c313c;
  height: 32px;
  line-height: 32px;
}

/deep/ .echarts_tooltip_i {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 5px;
}

/*投放效果报告*/
.results_statistical {
  margin: 24px;
  border-radius: 2px;
  background: #fff;

  .table_box {
    padding: 24px 32px;

    .info_box {
      height: 32px;
      background: rgba(230, 247, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(145, 213, 255, 1);
      line-height: 32px;
      padding: 0 16px;
      position: relative;
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      margin-bottom: 16px;

      > i {
        color: #fff;
        background: rgba(24, 144, 255, 1);
        border-radius: 50%;
      }

      span {
        color: rgba(24, 144, 255, 1);
      }

      .export_excel {
        position: absolute;
        right: 96px;
        cursor: pointer;
      }
      .monitoring_report {
        position: absolute;
        right: 16px;
        cursor: pointer;
      }
      .explain-modal {
        position: absolute;
        right: 176px;
        cursor: pointer;
      }
    }
  }
  .page-wrap {
    float: unset;
    text-align: right;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  }
}

/*上传物料*/
.material_warp {
  width: 100%;
  height: 546px;
  margin: 0 auto;
  display: flex;
  border: 1px solid rgba(233, 233, 233, 1);

  .left_tags {
    width: 288px;
    padding: 8px;
    border-right: 1px solid rgba(233, 233, 233, 1);
    overflow-y: auto;

    li {
      border-radius: 4px;
      padding: 12px;
      cursor: pointer;
      margin-bottom: 8px;
      position: relative;

      h4 {
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
      }

      .active_icon {
        position: absolute;
        right: 12px;
        top: 27px;

        svg {
          font-size: 18px;
          color: rgba(82, 196, 26, 1);
        }
      }
      p {
        display: inline-block;
        background: rgba(0, 0, 0, 0.04);
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        padding: 0 8px;
        color: rgba(0, 0, 0, 0.65);
        margin-right: 8px;
        margin-top: 8px;
      }
      p:last-child {
        margin-right: 0;
      }

      span.active_icon {
        display: inline-block;
        width: 56px;
        height: 26px;
        line-height: 26px;
        background: rgba(250, 173, 20, 1);
        border-radius: 17px;
        color: #fff;
        font-size: 12px;
        text-align: center;
        top: 20px;
      }

      .pulling_audit {
        margin-top: 8px;

        button:nth-last-child(1) {
          margin-left: 8px;
        }
      }
    }
    .active_tag {
      background: rgba(0, 0, 0, 0.05);
    }
  }

  .right_conten {
    flex: 1;
    position: relative;

    header {
      height: 64px;
      border-bottom: 1px solid rgba(233, 233, 233, 1);
      line-height: 64px;
      text-align: center;

      .ant-form-item {
        margin-bottom: 0;
        height: 100%;

        .ant-form-item-label,
        .ant-form-item-control {
          line-height: 64px;
        }
      }
    }

    .icon_btn {
      position: absolute;
      right: 36px;
      bottom: 36px;
      width: 50px;

      .icon_wrap {
        display: inline-block;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        margin-bottom: 16px;
        cursor: pointer;
        border: 1px solid rgba(0, 0, 0, 0.2);
        line-height: 52px;
        text-align: center;
        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2);

        .anticon {
          svg {
            font-size: 21px;
            color: rgba(0, 0, 0, 0.2);
          }
        }
      }

      .icon_wrap:hover {
        border-color: rgba(23, 144, 255, 1);

        svg {
          color: rgba(23, 144, 255, 1);
        }
      }
      .disable_icon_wrap {
        cursor: not-allowed;
        background: rgba(241, 241, 241, 1);
        border: 2px solid rgba(0, 0, 0, 0.2);

        & :hover {
          border: 2px solid rgba(0, 0, 0, 0.2);

          svg {
            color: rgba(0, 0, 0, 0.2);
          }
        }
      }
    }

    .content_main {
      display: flex;
      justify-content: center;
      padding: 24px 0 0;
      .content_warp {
        width: 240px;
        border-radius: 8px;

        .change_material_body {
          width: 100%;
          /*height: 376px;*/
          /*background: url("../../../public/images/fullMaterial.png") no-repeat;*/
          background-size: contain;
          position: relative;

          /deep/ .ant-upload {
            width: 100%;
            margin: 0 auto;
            position: relative;
            /* top: 22px; */
            height: 382px;
            /*border: 1px dashed rgba(0,0,0,0.25);*/
            border-radius: 0;
          }

          .m-updataing {
            height: 220px;
            /*padding-top: 40px;*/

            .u-ant-upload-img {
              margin: 0 auto;
              width: 35px;
              height: 28px;
              font-size: 20px;

              i {
                color: #1890ff;

                svg {
                  width: 37px;
                  height: 30px;
                }
              }
            }

            .u-ant-upload-text {
              font-size: 14px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.85);
              line-height: 22px;
            }

            .u-ant-upload-info {
              font-size: 12px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.43);
              line-height: 20px;
            }
          }

          .m-updataed {
            position: absolute;
            top: 17px;
            /*left: 21px;*/
            cursor: pointer;

            .m-bg-img {
              /*width: 222px;*/
              /*height: 334px;*/
              cursor: pointer;
              position: relative;
              img {
                width: 240px;
                /*height: 100%;*/
              }

              video {
                width: 100%;
                height: 100%;
                cursor: pointer;
              }
              span {
                width: 126px;
                height: 32px;
                line-height: 32px;
                border-radius: 17px;
                display: block;
                background: rgba(239, 239, 239, 1);
                margin: 12px auto 16px;
                text-align: center;
                font-size: 14px;
                color: rgba(0, 0, 0, 0.65);
                position: absolute;
                bottom: -68px;
                left: 50%;
                transform: translateX(-50%);
              }
              .span_new {
                background: rgba(24, 144, 255, 0.15);
                color: rgba(24, 144, 255, 1);
              }
            }

            .m-img-info {
              position: absolute;
              top: 0;
              width: 240px;
              /*width: 222px;*/
              /*height: 334px;*/

              .u-ant-upload-img {
                position: relative;
                margin: 0px auto 12px;
                padding-top: 121px;
                width: 35px;
                height: 28px;
                font-size: 20px;
                box-sizing: content-box;

                i {
                  position: absolute;

                  & :first-child {
                    color: #1890ff;

                    svg {
                      width: 37px;
                      height: 30px;
                    }
                  }

                  & :last-child {
                    bottom: -2px;
                    right: -2px;
                    color: #52c41a;

                    svg {
                      width: 14px;
                      height: 14px;
                    }
                  }
                }
              }

              .u-ant-upload-text {
                font-size: 14px;
                /*font-family: PingFangSC-Regular;*/
                font-weight: 400;
                color: rgba(0, 0, 0, 0.85);
                line-height: 22px;
                text-align: center;
                margin-bottom: 10px;
              }

              .u-ant-upload-info {
                font-size: 12px;
                /*font-family: PingFangSC-Regular;*/
                font-weight: 400;
                color: rgba(0, 0, 0, 0.43);
                line-height: 20px;
                text-align: center;
              }

              .u-clost-updata {
                position: absolute;
                top: -10px;
                right: -10px;
                width: 20px;
                height: 20px;
                cursor: pointer;
                color: #de2c2c;

                svg {
                  width: 100%;
                  height: 100%;
                }
              }
            }
          }
        }
      }
      .new_content_warp {
        margin-left: 48px;
      }
    }
  }
}

/*投放中计划 投放区域-查看全部 这是091要改的页面*/
.totalArea_modal {
  .totalArea_header {
    .info_box {
      height: 32px;
      background: rgba(230, 247, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(145, 213, 255, 1);
      line-height: 32px;
      padding: 0 16px;
      position: relative;
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      margin-bottom: 16px;

      > i {
        color: #fff;
        background: rgba(24, 144, 255, 1);
        border-radius: 50%;
      }

      span {
        color: rgba(24, 144, 255, 1);
      }
    }
    /deep/ .ant-row {
      margin-bottom: 16px;

      .ant-input {
        width: 80%;
      }
    }
  }
  .totalArea_table {
    max-height: 595px;
    min-height: 320px;
    overflow-y: auto;

    .show_img_btn {
      cursor: pointer;
      color: #1890ff;
    }

    .not_have_img {
      color: rgba(0, 0, 0, 0.25);
      cursor: unset;
    }

    .ant-badge-not-a-wrapper {
      vertical-align: unset;
    }
  }
}
.screen_capture {
  /deep/ .ant-modal-content {
    .ant-modal-close {
      .ant-modal-close-x {
        width: 57px;
        height: 57px;
        line-height: 57px;
      }
    }
  }
  /deep/ .ant-modal-header {
    .ant-modal-title {
      height: 24px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
    }
  }
  /deep/ .ant-modal-body {
    padding: 24px 32px;
    min-height: 215px;
    max-height: 575px;
    overflow-y: scroll;
  }
}
</style>
<style lang="scss">
*::-webkit-scrollbar-track {
  box-shadow: unset;
}
*::-webkit-scrollbar-thumb {
  box-shadow: unset;
}
/*播放量*/
.derail_card {
  border-radius: 2px;
  .ant-card-head {
    padding: 0 32px;
  }
  .ant-card-head-title {
    h4 {
      font-weight: 600;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.85);
    }
  }
  .ant-card-body {
    padding: 0 0 8px;

    .detail_table {
      .ant-table-body,
      .ant-table-thead {
        td,
        th {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 16px 8px;
        }
      }
    }
  }
  .ant-calendar-picker {
    width: 256px;
    margin-left: 16px;
  }
}

/*监播报告*/
.report-model {
  .ant-modal-body {
    text-align: center;
    padding: 16px 24px 32px;
  }
  .cards-wrap {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    position: relative;
    .card {
      width: 272px;
      height: 129px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      border: 1px solid rgba(232, 232, 232, 1);
      border-bottom: none;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-right: 25px;
      margin-bottom: 25px;
      overflow: hidden;
      .card-top {
        padding: 12px;
        box-sizing: border-box;
        .card-img {
          width: 64px;
          height: 64px;
          background: rgba(216, 216, 216, 1);
          border-radius: 4px;
          margin-right: 16px;
          float: left;
        }
        .card-time,
        .card-count {
          float: left;
        }
        .card-time {
          color: rgba(0, 0, 0, 0.85);
          div {
            display: inline-block;
            span {
              font-size: 12px;
              color: rgba(0, 0, 0, 0.45);
              transform: scale(0.83);
              display: inline-block;
            }
            width: 32px;
            height: 16px;
            line-height: 16px;
            background: rgba(0, 0, 0, 0.06);
            border-radius: 2px;
            text-align: center;
          }
        }
        .card-count {
          span {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.45);
          }
          span:nth-child(2) {
            margin: 0 8px;
            color: #e8e8e8;
          }
        }
      }
      .card-bottom {
        display: flex;
        height: 40px;
        background: rgba(247, 249, 250, 1);
        border-radius: 0px 0px 2px 2px;
        padding: 12px 0;
        box-sizing: border-box;
        border-bottom: 1px solid #e8e8e8;
        div {
          flex: 1;
          cursor: pointer;
          text-align: center;
          border-right: 1px solid #e8e8e8;
        }
        div:last-child {
          border-right: none;
        }
        .anticon {
          color: rgba(0, 0, 0, 0.45);
        }
        div:hover,
        div:hover .anticon {
          color: #1890ff;
        }
      }
    }
    .card:last-child,
    .card:nth-child(3n) {
      margin-right: 0;
    }
  }
  .report-page {
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .ant-modal-close-x {
    line-height: 55px;
  }
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding: 0;
  padding-top: 12px;
  padding-bottom: 13px;
  font-size: 14px;
  font-family: 'PingFangSC-Medium, PingFang SC';
  color: rgba(0, 0, 0, 0.85);
  line-height: 21px;
  text-align: center;
}
.click-toast {
  > p {
    margin-bottom: 13px;
    font-size: 14px;
    font-family: 'PingFangSC-Regular,PingFang SC';
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 22px;
  }
  .click-toast-footer {
    display: flex;
    justify-content: space-around;
    .ant-btn:nth-child(1) {
      height: 24px;
      width: 72px;
    }
    .ant-btn:nth-child(2) {
      height: 24px;
      width: 114px;
    }
  }
  .explain-modal-title {
    font-size: 14px;
    font-family: 'PingFangSC-Semibold,PingFang SC';
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    line-height: 22px;
  }
}
</style>
